import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'

const InventoryHome = () => {
 
    const distID = localStorage.getItem('distributorId');
    const boostID = localStorage.getItem('companyIdBooster');
    const parisID = localStorage.getItem('companyIdParis'); 
  
    const { data, error, isLoaded } = GetRequest(`/Inventory/GetLessStockInventory/${distID}`);
      

  if (error !== null) {
    return <Error data="Inventory"/>;
  }
  if (!isLoaded) {
    return  <Loading />;
  }
if(data.result.length !== 0) {
  return (
    <div className="col-md-6">  
        <div className="card card-success">
            <div className="card-header">
                <h4 className="card-title">Inventory</h4>
            </div>
            <div className="card-body MHSScroll"> 
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Status</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {  
                            data.result && data.result.map(item => (
                                <tr key={item.productItemId}>
                                    
                                       <td>{item.productItemName} </td>  
                                       <td> {item.qty}</td>
                                       <td><div className="progress progress-xs"><div className={`progress-bar ${item.stockQuantityColorIndicator}`}   style={{width: item.percentWithMinimumRequiredQuantity + "%"}}></div></div> </td> 
                                       <td><span className={`badge ${item.stockQuantityColorIndicator}`}>{item.percentWithMinimumRequiredQuantity}%</span></td>
                                </tr> 
                            ))
                        } 
                    </tbody>
                </table>
            </div> 
        </div> 
    </div>
  )
} else {
    return (
        <div className="col-md-6">  
            <div className="card card-success">
                <div className="card-header">
                    <h4 className="card-title">Inventory</h4>
                </div>
                <div className="card-body MHSScroll"> 
                    <table className="table table-sm"> 
                        <tbody>
                                <tr>
                                    <td className="NoDataAvailableText"> No Data Available </td>
                                </tr>
                        </tbody>
                    </table>
                </div> 
            </div> 
        </div>
      )

}

}

export default InventoryHome